import React from 'react';
import { FormikButtonGroup } from '../../../components/FormikButtonGroup/FormikButtonGroup';
import { QuestionItem } from '../../types/QuestionItem';

export const ExpectedDuration: React.FC = () => {
  const durationOptions: QuestionItem<number>[] = [
    {
      displayName: '24',
      value: 24,
      icon: '',
      availableIn: true,
      trackingName: 'radioButtonTerms24'
    },
    {
      displayName: '30',
      value: 30,
      icon: '',
      availableIn: true,
      trackingName: 'radioButtonTerms30'
    },
    {
      displayName: '36',
      value: 36,
      icon: '',
      availableIn: true,
      trackingName: 'radioButtonTerms36'
    },
    {
      displayName: '42',
      value: 42,
      icon: '',
      availableIn: true,
      trackingName: 'radioButtonTerms42'
    },
    {
      displayName: '48',
      value: 48,
      icon: '',
      availableIn: true,
      trackingName: 'radioButtonTerms48'
    },
    {
      displayName: '54',
      value: 54,
      icon: '',
      availableIn: true,
      trackingName: 'radioButtonTerms54'
    },
    {
      displayName: '60',
      value: 60,
      icon: '',
      availableIn: true,
      trackingName: 'radioButtonTerms60'
    }
  ];

  return (
    <FormikButtonGroup
      itemList={durationOptions}
      inputType="radio"
      propName="expectedDuration"
      required={true}
      auto={true}
      small={true}
      fieldValueType="scalar"
      data-testid="formikButtonGroup-expectedDuration"
    />
  );
};
